import React, { useState } from 'react'; 
import Logo from "../assets/Logo"; 
import axios from "axios"; 
import { Toaster, toast } from "sonner"; 
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom"; 
import { Button } from "@nextui-org/react"; 
import Footer from "../components/Footer"; 
import { Link } from "react-router-dom"; 

const apiURL = import.meta.env.VITE_ENVIRONMENT === "development" ? "http://localhost:5000" : import.meta.env.VITE_API_URL; 

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); 

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${apiURL}/api/forgot-password`, { email });
      toast.success(response.data.message || "Password reset link sent! check your email");
		setTimeout(()=>{
		  navigate("/login"); 
		}, 3000); 
    } catch (error) {
		console.log("checking error"); 
		console.log(error.request); 
		console.log(error.response); 
      const errorMessage = error.response?.data || "Error sending password reset link"; 
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="p-8 rounded-lg shadow-lg max-w-md w-full bg-white">
          <div className="flex flex-col justify-center items-center mb-6">
            <Logo size="100px" />
            <p className="text-2xl sm:text-[1.7rem] lg:text-[1.8rem] font-medium">InsightExchangeCo</p>
          </div>
          <h2 className="text-xl font-bold mb-6 text-center text-gray-700">Forgot Password</h2>
          <form onSubmit={handleForgotPassword}>
            <div className="mb-4">
              <label htmlFor="email" className="block text-gray-600 mb-2">Email</label>
              <input 
                type="email" 
                id="email" 
                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            <Button 
              type="submit"
              isLoading={loading}
              color="primary"
              className="w-full bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={loading}
            >
              Send Password Reset Link
            </Button>
            <Toaster position="top-center" richColors />
            <p className="text-sm text-center text-gray-600 mt-4">
              <Link to="/login" className="text-blue-500">Back to Login</Link>
            </p>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default ForgotPasswordPage;

